import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import fr from './lang/fr.json';
import gb from './lang/gb.json';
import mt from './lang/mt.json';
import pt from './lang/pt.json';
import us from './lang/us.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      gb: {
        common: gb
      },
      fr: {
        common: fr
      },
      mt: {
        common: mt
      },
      pt: {
        common: pt
      },
      us: {
        common: us
      }
    },
    lng: "us",
    fallbackLng: "us",
    interpolation: { escapeValue: false },  // React already does escaping
    defaultNS: "us"
  });

  export default i18n;
